<template>
  <div class="error">
    <static-image class="icon" src="@/assets/images/error/network" />
    <h1>{{ $t('message.errorTitle') }}</h1>
    <p>{{ $t('message.errorDesc') }}</p>
    <van-button type="primary" round @click="handleReload">
      {{ $t('message.reload') }}
    </van-button>
  </div>
</template>

<script setup lang="ts">
const emits = defineEmits<{
  (e: 'reload'): void
}>()
const props = withDefaults(
  defineProps<{
    handleError?: boolean
  }>(),
  {
    handleError: false
  }
)
const handleReload = () => {
  if (props.handleError) {
    emits('reload')
  } else {
    window.location.reload()
  }
}
</script>

<style lang="scss" scoped>
.error {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 16px;

  .icon {
    width: 118px;
    height: 118px;
  }

  h1 {
    margin-top: 8px;
    margin-bottom: 0;
    font-size: 14px;
    color: $c-black1;
    padding: 0 16px;
  }

  p {
    margin-top: 8px;
    font-size: 12px;
    line-height: 1.5;
    color: $c-black3;
    padding: 0 16px;
  }
}
</style>
